import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaMoon, FaSun } from 'react-icons/fa';

export default function History() {
  const [dark, setDark] = useState(true);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await fetch('https://api.mogym.ir/api/plan/history', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        const data = await res.json();
        if (!res.ok) throw new Error(res.Message);
        setHistory(data.Result || []);
      } catch (err) {
        setError('خطا در دریافت اطلاعات تاریخچه');
      }
      setLoading(false);
    };

    fetchHistory();
  }, []);

  const statusColor = (status) => {
    switch (status) {
      case 'Registered':
        return 'text-white-500';
      case 'Paid':
        return 'text-orange-500';
      case 'Canceled':
        return 'text-red-500';     
      case 'PaymentPending':
        return 'text-yellow-500';
              case 'Created':
        return 'text-green-500';
                      case 'TrainerReview':
        return 'text-blue-500';
      default:
        return 'text-gray-500';
    }
  };

  const setStatus = (status) => {
    switch (status) {
      case 'Registered':
        return 'ثبت شده';
      case 'Paid':
        return 'پرداخت شده';
      case 'Canceled':
        return 'لغو شده';     
      case 'PaymentPending':
        return 'در حال پرداخت';
              case 'Created':
        return 'ارسال شده';
      default:
        return 'نامشخص';
    }
  };

  const handleDetails = (planId) => {
    localStorage.setItem('planId', planId);
    navigate(`/active-plan`);
  };

  const handleFeedback = (planId) => {
    navigate('/feedback', { state: { planId } });
  };

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white px-4 py-8 font-vazir">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-2xl font-bold text-center mb-6">تاریخچه برنامه‌ها</h1>

          {loading && <p className="text-center">در حال دریافت اطلاعات...</p>}
          {error && <p className="text-red-500 text-center">{error}</p>}
          {history.length === 0 && !loading && (
            <p className="text-center text-gray-500">هیچ برنامه‌ای یافت نشد.</p>
          )}

          <div className="space-y-4">
            {history.map((item, index) => (
              <div
                key={index}
                className="border dark:border-gray-700 rounded-xl p-4 bg-gray-50 dark:bg-[#1c1f2b]"
              >
                <div className="flex justify-between items-center mb-3">
                  <span className="font-bold">{item.PlanTitle}</span>
                  <span className={`text-sm font-medium ${statusColor(item.Status)}`}>
                    {setStatus(item.Status)}
                  </span>
                </div>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
                 نوع برنامه: {item.PlanType}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">
                  تاریخ ایجاد: {new Date(item.CreatedAt).toLocaleDateString('fa-IR')}
                </p>
                {/*<p className="text-sm text-gray-600 dark:text-gray-300 mb-3">
                  مبلغ: {item.Price?.toLocaleString()} تومان
                </p>*/}
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">
                  کد رهگیری: {item.TrackingCode} 
                </p>
                <div className="flex gap-2 flex-wrap">
                  <button
                    onClick={() => handleDetails(item.PlanId)}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1 rounded-xl text-sm"
                  >
                    مشاهده جزئیات
                  </button>

                  {item.Status === 'Created' && (
                    <button
                      onClick={() => handleFeedback(item.PlanId)}
                      className="bg-green-600 hover:bg-green-700 text-white px-4 py-1 rounded-xl text-sm"
                    >
                      ثبت بازخورد
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* دکمه تغییر تم */}
        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button>
      </div>
    </div>
  );
}
